import './app.css';



/* is production */
const isProd = process.env.NODE_ENV === 'production';
/*
console.log(isProd);
*/


/* data */
const data = require('./js/data.json');
/*
console.log(data);
*/



/* analytics */
const analytics = require('universal-ga');
analytics.initialize(data.meta.trackingID);
analytics.pageview('/index');

if (data.meta.clientTrackingID.length > 0) {
    analytics.create(data.meta.clientTrackingID, 'clientTracker');
    analytics.name('clientTracker').pageview('/index');
}



/* jquery 
window.$ = window.jQuery = require('jquery');
*/
/* swiper */
const Swiper = require('swiper');

/* typed.js */
const Typed = require('typed.js');

/* text scrambler */
import ScrambleText from 'scramble-text';

/* eslint-disable no-unused-vars */
/* greensock and draggable */
import {TweenMax, Power2, TimelineLite, CssRule} from "gsap";
import Draggable from "gsap/Draggable";
import ScrollToPlugin from "gsap/ScrollToPlugin";
/*
import CSSPlugin from "gsap/CSSPlugin";
import CSSRulePlugin from "gsap/CSSRulePlugin";
*/
 /* eslint-enable no-inner-declarations */

/* service worker */
if ('serviceWorker' in navigator && isProd) {
    navigator.serviceWorker.register('./sw.js');
}



/* likes */
require('../node_modules/ilyabirman-likely/release/likely.js');

/* eslint-disable no-unused-vars */
/* eslint-disable no-console */

/* eslint-disable no-extra-parens */

window.onload = function() {
	analytics.event('event', 'load', { eventLabel: 'page loaded' });
	analytics.name('clientTracker').event('event', 'load', { eventLabel: 'page loaded' });
}



var width = 100,
    perfData = window.performance.timing, // The PerformanceTiming interface represents timing-related performance information for the given page.
    EstimatedTime = -(perfData.loadEventEnd - perfData.navigationStart),
    time = parseInt((EstimatedTime/1000)%60)*100;

var PercentageID = document.getElementById("percent"),
        start = 0,
        end = 100,
        durataion = time;
        animateValue(PercentageID, start, end, durataion);

var animationDuration = durataion/1000;
TweenMax.to(PercentageID, animationDuration, {width: "0%" ,ease: Power1.easeOut})

/* eslint-enable no-extra-parens */

function animateValue(id, start, end, duration) {
    var range = end - start,
      current = start,
      increment = end > start? 1 : -1,
      stepTime = Math.abs(Math.floor(duration / range)),
      obj = document.getElementById("percent");
    
    var timer = setInterval(function() {
        current += increment;        
        document.getElementById('perctime').innerHTML = current + "%";
      //obj.innerHTML = current;
        if (current === end) {
            clearInterval(timer);
        }
    }, stepTime);
}

setTimeout(function(){
  document.getElementById('preloader-container').classList.add('hide');
}, time);

var topMenu = document.getElementById("topnav");
var sendButton = document.getElementById("sendbutton");
const menuToggler = document.getElementById("menutoggle");
const mobileMenu = document.getElementById("mobilemenu");
const mobileShareList = document.getElementById("share-mobile__list");
const centerBlock = document.getElementById("centercont");

/* mobile device detection */
var isMobile = false; 
if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) 
    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {isMobile = true;}


if (isMobile){
	let fy = document.getElementById("trailer");
	let sy = document.getElementById("automove");
	let ratio = window.devicePixelRatio || 1;
	let windowWidth = screen.width - 50;
	fy.removeAttribute("width");
	fy.setAttribute("width", windowWidth);
	fy.removeAttribute("height");
	sy.removeAttribute("width");
	sy.setAttribute("width", windowWidth);
	sy.removeAttribute("height");
	let stationimg = document.getElementById("stationimg");
	stationimg.setAttribute('src', 'img/secondpage/sous-light-mobile.png');
	/*
	document.insertBefore(mobileMenu, topMenu);
	*/
	let mobElements = document.querySelectorAll('.moveme');
	for(let i = 0; i<mobElements.length; i++) {
		let mobElement = mobElements[i];
			mobileShareList.appendChild(mobElement);
		}
	centerBlock.style.width = screen.width + "px";
	centerBlock.style.height = screen.height + "px";

	let leftbl = document.getElementById('leftbl');
	let rightbl = document.getElementById('rightbl');
	let swipercnt = document.getElementById('swipercnt');
	/*
	leftbl.remove();
	rightbl.remove();
	*/
	swipercnt.remove();

	window.addEventListener("load",function() {
	// Set a timeout...
		setTimeout(function(){
			// Hide the address bar!
			window.scrollTo(0, 1);
		}, 0);
	});
	
}

var audioSwitch = document.getElementById('musicswitch');
var audioTrack = document.getElementById('audio');

audioSwitch.addEventListener('click', function () {
	if (audioTrack.currentTime === 0) {
            audioTrack.play();            
        }

        if (audioTrack.muted === false) {
            audioTrack.muted = true;
            analytics.event('button', 'click', { eventLabel: 'pause music' });
            analytics.name('clientTracker').event('button', 'click', { eventLabel: 'pause music' });
            musicbuttonToggler();

        } else {
            audioTrack.muted = false;
            analytics.event('button', 'click', { eventLabel: 'play music' });
            analytics.name('clientTracker').event('button', 'click', { eventLabel: 'pause music' });
            musicbuttonToggler();
        }
});

function musicbuttonToggler(){
	let musImages = audioSwitch.getElementsByTagName('img');
	for(let i = 0; i<musImages.length; i++){
		musImages[i].classList.toggle('hidden');
	}
}

/* topmenu animation */

mobileMenu.style.display = 'none';

menuToggler.onclick = function() {
	if ( mobileMenu.hasClass('hidden') ){
		mobileMenu.style.display = 'flex';
		mobileMenu.classList.remove('hidden');
		menutoggle.classList.add('cross');

	} else {
		mobileMenu.classList.add('hidden');
		menutoggle.classList.remove('cross');
		setTimeout(function(){
			mobileMenu.style.display = 'none';
		},1600);
	}
  };


var textPlay = new ScrambleText(sendButton,
	{
		timeOffset : 20,
		chars: [
			'й','ц','у','к','е',
			'н','г','ш','щ','з',
			'ф','ы','в','а','п',
			'п','р','о','л','д',
			'я','ч','с','м','и',
			'т','ь','б'
		]
	}
).start().play();

/* Анимация меню */

var topMenuBg = document.getElementById("topmenubg");
var ShareButtonOne = document.getElementById("hb1");
var ShareButtonTwo = document.getElementById("hb2");
var ShareButtonThree = document.getElementById("hb3");
const ship = document.getElementById("sous");
const niceBg = document.getElementById("transbg");
const handContainer = document.getElementById("hand-container");

var menuAnimate = new TimelineLite();

/*
menuAnimate.set(topMenuBg, 1, {
  width: 100%,
}).to(hb1, 1, {
		opacity: 1,
	}
);
*/
/*
menuAnimate.stop();
menuAnimate.add( TweenLite.to(topMenuBg, 1, {width:"100%"}) );
menuAnimate.add( TweenLite.to(hb3, 1, {opacity:1, visibility: 'visible'}) );
menuAnimate.add( TweenLite.to(hb2, 1, {opacity:1, visibility: 'visible'}) );
menuAnimate.add( TweenLite.to(hb1, 1, {opacity:1, visibility: 'visible'}) );
menuAnimate.stop();
*/


if ( !isMobile ) {
topMenu.addEventListener("mouseenter", mEnter );

topMenu.addEventListener("mouseleave", mLeave );

}

function mEnter (){

topMenu.removeEventListener("mouseenter", mEnter );

setTimeout(function(){
		topMenu.addEventListener("mouseenter", mEnter );
	},1300);

TweenMax.to(hb3, 0.02, {visibility: "visible", display: "block"});
TweenMax.to(hb2, 0.02, {visibility: "visible", display: "block"});
TweenMax.to(hb1, 0.02, {visibility: "visible", display: "block"});
TweenMax.to(topMenuBg, 1.2, {
  delay: 0.2,
  width: "100%",
  ease: Power4.easeOut
});


TweenMax.to(hb3, 1, {
  delay: 0.5,
  opacity: 1,
  ease: Power4.easeOut
});
TweenMax.to(hb2, 2, {
  delay: 0.7,
  opacity: 1,
  ease: Power4.easeOut
});
TweenMax.to(hb1, 3, {
  delay: 0.9,
  opacity: 1,
  ease: Power4.easeOut
});

TweenMax.to(hb3, 0.05, {
  delay: 1.0,
  opacity: 0,
  repeat:3, yoyo:true
});
TweenMax.to(hb2, 0.05, {
  delay: 1.2,
  opacity: 0,
  repeat:3, yoyo:true
});
TweenMax.to(hb1, 0.05, {
  delay: 1.3,
  opacity: 0,
  repeat:3, yoyo:true
});
}

function mLeave (){
	TweenMax.to(topMenuBg, 1, {
  delay: 0.1,
  width: "390",
  ease: Power4.easeOut
});

TweenMax.to(hb3, 0.5, {
  delay: 0.05,
  opacity: 0,
  ease: Power4.easeOut
});
TweenMax.to(hb2, 0.5, {
  delay: 0.06,
  opacity: 0,
  ease: Power4.easeOut
});
TweenMax.to(hb1, 0.5, {
  delay: 0.08,
  opacity: 0,
  ease: Power4.easeOut
});
TweenMax.to(hb3, 0.2, {visibility: "hidden", display: "none", delay: 0.5});
TweenMax.to(hb2, 0.2, {visibility: "hidden", display: "none", delay: 0.5});
TweenMax.to(hb1, 0.2, {visibility: "hidden", display: "none", delay: 0.5});
}




/*
var tl = new TimelineLite();

tl.to(hb3, 0.02, {visibility: "visible", display: "block"});
tl.to(hb2, 0.02, {visibility: "visible", display: "block"});
tl.to(hb1, 0.02, {visibility: "visible", display: "block"});
tl.to(topMenuBg, 1.2, {
  delay: 0.2,
  width: "100%",
  ease: Power4.easeOut
});
tl.to(hb3, 1, {
  delay: 0.5,
  opacity: 1,
  ease: Power4.easeOut
}).to(hb2, 2, {
  delay: 0.7,
  opacity: 1,
  ease: Power4.easeOut
}).to(hb1, 3, {
  delay: 0.9,
  opacity: 1,
  ease: Power4.easeOut
}).to(hb3, 0.05, {
  delay: 1.0,
  opacity: 0,
  repeat:3, yoyo:true
}).to(hb2, 0.05, {
  delay: 1.2,
  opacity: 0,
  repeat:3, yoyo:true
}).to(hb1, 0.05, {
  delay: 1.3,
  opacity: 0,
  repeat:3, yoyo:true
});

tl.reverse();

topMenu.addEventListener("mouseenter", function(e) {
	tl.pause()
	tl.play();
});

topMenu.addEventListener("mouseleave", function(e) {
	tl.pause();
	tl.reverse();
});
*/

/* sous launch manual */

function manualDocking(){
	closeAllModals();
	document.getElementById("first-pins").classList.add('hidepins');
	manualButton.removeEventListener("click", manualDocking);
	handContainer.classList.remove("hidden");
	let direction = "x";
	if (isMobile) {
		direction = "y";
	} 
	Draggable.create(ship, {
		type: direction,
		bounds: document.getElementById("souscontainer"),
		edgeResistance:0.96,
		throwProps:true,
		dragResistance: 0.7,
		endX: "200",	
		onDragStart:function() {
			handContainer.classList.add("hidden");
			analytics.event('event', 'process', { eventLabel: 'user try to drag ship in manual docking' });
			analytics.name('clientTracker').event('event', 'process', { eventLabel: 'user try to drag ship in manual docking' });
		},
		onRelease:function() {
			handContainer.classList.remove("hidden");
		},
		onDragEnd:function() {
			
		},
		onDrag: landCheck
	});
}


/* eslint-disable no-extra-parens */

/* station connect */

var checkOne = false,
	checkTwo = false,
	thirdend = false,
	fourthend = false,
	problemOne = false,
	problemTwo = false,
	problemThree = false,
	stopBlink = false;

function landCheck(){
	/*
	let boxHeight = $(this.target).height();
	let boxWidth = $(this.target).width();
	*/

	let boxHeight = this.target.clientHeight;
	let boxWidth = this.target.clientWidth;
	let shipHeight = document.getElementById('sous').clientHeight;

	/*
  	if(this.x > (this.maxX + boxWidth - 300) || this.x < (this.minX -boxWidth) || this.y > (this.maxY + boxHeight) || this.y < (this.minY -boxHeight) ) {
    //if out of bounds
    TweenLite.set(this.target, {background:"red"});
    this.kill();
  }*/
  if (isMobile) {
		if( this.y > (this.maxY + boxHeight - shipHeight) || this.y < (this.minY -boxHeight - shipHeight) ) {
	    //if out of bounds
	    /*
	    TweenLite.set(this.target, {background:"red"});
	    */
	    this.kill();
	    niceBg.classList.add("hidden");
	    analytics.event('event', 'complete', { eventLabel: 'manual docking mobile complete' });
	    analytics.name('clientTracker').event('event', 'complete', { eventLabel: 'manual docking mobile complete' });
	    stepFour();
	  }

  } else {
		if( this.x < (this.minX -boxWidth + 297) ) {
	    //if out of bounds
	    /*
	    TweenLite.set(this.target, {background:"red"});
	    */
	    this.kill();
	    niceBg.classList.add("hidden");
	    analytics.event('event', 'complete', { eventLabel: 'manual docking desktop complete' });
	    analytics.name('clientTracker').event('event', 'complete', { eventLabel: 'manual docking desktop complete' });
	    stepFour();
	  }
  }
  
}


/* eslint-enable no-extra-parens */

/* app Swiper */

const fpg = document.getElementById("fpg");
const spg = document.getElementById("spg");
const secondDarkbg = document.getElementById("darkbgSecond");



document.getElementById("startmission").onclick = function() {
    appSwiper.slideTo(1);
    timedThirdStep();
  };

var appSwiper = new Swiper ('.main-swiper-container', {
    mousewheelControl: false,
    watchActiveIndex: true,
    speed: 1000,
    effect: 'fade',
    onlyExternal: true,
    preventClicks: false,
    preventClicksPropagation: false,
    noSwiping: true,
    onInit: function (swiper){
		audioTrack.play();		
    },
    onSlideChangeEnd: function (swiper) {
		switch (swiper.activeIndex){
			case 0:
			 
			 break;
			case 1:
			 secondDarkbg.classList.remove("visible");
			 setTimeout(function(){
				secondDarkbg.style.display = 'none';
			},1700);
			 /*
			 launchBlinking();
			 */
			 break;
			case 2:
			 
			 break;
			default:	
			console.log( 'другой слайд' );
		}
    }
  })

/* swiper first slide inner */
var tfirst = false,
    tsecond = false,
    tthird = false;
if (isMobile){
/*
document.getElementById('killer').remove();
document.getElementById('diller').style.height = "auto";

let mainSwiper = new Swiper ('.swiper-container', {
    pagination: '.swiper-pagination',
    direction: 'vertical',
    watchActiveIndex: true,
    paginationClickable: true,
    slidesPerView: 'auto',
    freemode: true,
    onInit: function (){
      typeThisMobile();
    }
  })
  */
  typeThisMobile();
} else{

let mainSwiper = new Swiper ('.swiper-container', {
    pagination: '.swiper-pagination',
    direction: 'vertical',
    mousewheelControl: true,
    watchActiveIndex: true,
    paginationClickable: true,
    speed: 1000,
    effect: 'coverflow',
    coverflow: {
	  rotate: 20,
	  stretch: 2,
	  depth: 50,
	  modifier: 1,
	  slideShadows : false
	},
    onInit: function (swiper){
      typeThis(swiper.activeIndex + 1);
    },
    onSlideChangeEnd: function (swiper) {
		switch (swiper.activeIndex){
			case 0:
			 typeThis(swiper.activeIndex + 1);
			 analytics.event('event', 'complete', { eventLabel: 'first page slide changed' });
			 break;
			case 1:
			 typeThis(swiper.activeIndex + 1);
			 break;
			case 2:
			 typeThis(swiper.activeIndex + 1);
			 break;
			default:	
			alert( 'другой слайд' );
		}
	}
  })
}

/* eslint-disable no-inner-declarations */

function typeThisMobile(){
	var typedMobile = new Typed("#typecontainer__inner", {
			    strings: [data.firstpage.slidetextthird],
			    typeSpeed: 2,
			    showCursor: false	
			  });
 }

 function typeThis(slide){
	switch (slide) {
		case 1:
			if (!tfirst) {
			var typedFirst = new Typed(".fs-span", {
			    strings: [data.firstpage.slidetextfirst],
			    typeSpeed: 2,
			    showCursor: false	
			  });
			}
			tfirst = true;
		break;
		case 2:
			if (!tsecond){
			var typedSecond = new Typed(".ss-span", {
			    strings: [data.firstpage.slidetextsecond],
			    typeSpeed: 2,
			    showCursor: false	
			  });
			}
			tsecond = true;
		break;
		case 3:
			if (!tthird){
			var typedThird = new Typed(".ts-span", {
			    strings: [data.firstpage.slidetextthird],
			    typeSpeed: 2,
			    showCursor: false
			  });
			}
			tthird = true;
		break;
		default:
		alert( 'другой слайд' );
	}
 }

 /* eslint-enable no-inner-declarations */
 

/* first page timer */


	let timerContainer = document.getElementById("count");
	let counterClicksArr = document.getElementById("count").childNodes;
	counterClicksArr[1].classList.add("active");

	window.setInterval(function(){
	  countTimer();
	}, 1000);


function countTimer() {	
	var iterCont = parseFloat(timerContainer.getAttribute("data-sec"));
	let elementNum = iterCont;
	if ( iterCont  === 98){
		counterClicksArr[elementNum].classList.remove("active");
		counterClicksArr[2].classList.add("active");
		timerContainer.style.transform = "translateY(-0%)";
		iterCont = 1;
		timerContainer.setAttribute('data-sec', iterCont );
	} else {
	counterClicksArr[elementNum].classList.remove("active");
	counterClicksArr[elementNum+1].classList.add("active");
	timerContainer.style.transform = "translateY(-" + iterCont + "%)";
	iterCont  += 1;
	timerContainer.setAttribute('data-sec', iterCont );
	}
}

Element.prototype.hasClass = function(className) {
    return this.className && new RegExp("(^|\\s)" + className + "(\\s|$)").test(this.className);
};



/* modal-window */

/* modal-window-open */

var openModalButton = document.querySelectorAll(".openModal");

for(let i = 0; i<openModalButton.length; i++) {
    openModalButton[i].onclick = function(){

	let modalName = this.getAttribute('data-target');

	/* first pins open */
	if ( this.hasClass('firstpins') ) { firstPinTrigger(modalName)}

	/* second pins open */
	if ( this.hasClass('secondpins') ) {
		switch (modalName) {
		  case "stationOne":
		    
		    break;
		  case "stationTwo":
			if( problemOne === false ) {
				modalName = "stationOne";
			}
			break;
		  case "stationThree":
		    if( problemOne === false && problemTwo === false) {
				modalName = "stationOne";
		    }
			if( problemOne === true && problemTwo === false) {
				modalName = "stationTwo";
		    }
			break;
		  default:
		    console.log('secondpins switch error')
		}
		/*
		secondPinTrigger(modalName);
		*/
		openModal(modalName);
	} else {
		openModal(modalName);
	}

	}
}

function secondPinTrigger(e){	
	switch (e) {
		case "stationOne":
		    problemOne = true;
		    colorMyPin(e);
		    break;
		case "stationTwo":
			problemTwo = true;
			colorMyPin(e);
		    break;
		case "stationThree":
			problemThree = true;
			colorMyPin(e);
			fourthend = true;
		    break;
		default:
		    console.log('secondPinTrigger switch error')
	}
}

function colorMyPin(pinname){
	let pins = document.querySelectorAll(".secondpins");
	for(let i = 0; i<pins.length; i++){
		let ourPin = pins[i].getAttribute('data-target');
		if (ourPin === pinname) {
			pins[i].classList.add('green');
			pins[i].classList.remove('red');
			pins[i].classList.remove('signal');
		}		
	}
	switch (pinname) {
			case "stationOne":
				for(let i = 0; i<pins.length; i++){
					let ourPin = pins[i].getAttribute('data-target');
					if (ourPin === "stationTwo"){
						pins[i].classList.add('signal');
					}
				}
				break;
			case "stationTwo":
				for(let i = 0; i<pins.length; i++){
					let ourPin = pins[i].getAttribute('data-target');
					if (ourPin === "stationThree"){
						pins[i].classList.add('signal');
					}
				}
				break;
			default:	
		}
}

function closeAllModals() {
	let modals = document.querySelectorAll(".modal");
	for(let i = 0; i<modals.length; i++) {	    
		let modalAttr = modals[i].getAttribute('data-name');
		let modal = modals[i];		
		if ( !modal.hasClass('hidden') ){
			modal.classList.add("hidden");
		}
	}
}

function openModal (e){
	let modals = document.querySelectorAll(".modal");

	/* close all modals */
	for(let i = 0; i<modals.length; i++) {	    
		let modalAttr = modals[i].getAttribute('data-name');
		let modal = modals[i];		
		if ( !modal.hasClass('hidden') ){
			modal.classList.add("hidden");
		}
	}

	/* find modal to open */
	for(let i = 0; i<modals.length; i++) {	    
		let modalAttr = modals[i].getAttribute('data-name');
		let modal = modals[i];
		if ( modalAttr === e ){
			let modalcoords = modal.getBoundingClientRect();
			if ( modalcoords.top < 0) {
				modal.style.transform = "translate(-50% , -50%)"
			}
			modal.classList.remove("hidden");
			
			let text = modal.getElementsByTagName('p');
			let textBlock = modal.querySelectorAll('.textblock');
			let imgBlock = modal.querySelectorAll('.image');
			let trueTextBlocks = modal.querySelectorAll('.text');
			let trueTextBlock = trueTextBlocks[0];
			let image = imgBlock[0].getElementsByTagName('img');
			if ( modalAttr === "youtube" || modalAttr === "youtubemanual") {
				console.log();
			} else{

			let modalWidth = modal.clientWidth;
			let modalHeight = modal.clientHeight;
			let textHeight = text[0].clientHeight;
			let imgWidth = image[0].naturalWidth;
			let txtblkWith = modalWidth - imgWidth;
			/*
			let textWidth = text[0].clientWidth;
			*/
			let textToPrint = text[0].innerText;

			if(isMobile){console.log()} else {
					trueTextBlock.style.width = txtblkWith + "px";
					imgBlock[0].style.width = imgWidth + "px";
				}
			
			
			modal.style.width = modalWidth + "px";
			modal.style.height = modalHeight + "px";
			text[0].style.minHeight = textHeight + "px";
			
			/*
			text[0].style.width = textWidth + "px";
			*/

			text[0].innerHTML = "";

			let typedSecondModal = new Typed(text[0], {
			    strings: [textToPrint],
			    typeSpeed: 2,
			    showCursor: false,
			    onComplete: function() { 
					enableButton(modal);
			    }
			  });
			}

		}
	}	
}

function enableButton(modal) {
	let button = modal.querySelector('.disbut');
	if (button) {
			let getAtt = button.getAttribute('disabled')
			if ( button.disabled ){ button.disabled = false }
		}
	
}

/* station problems modal modifier */

const modalmodButton = document.querySelectorAll(".modalmod");

for(let i = 0; i<modalmodButton.length; i++) {
	modalmodButton[i].onclick = function(){
		let ourModal = this.getAttribute('data-child');
		/*
		if (ourModal === "stationOne") {
			stationOneModalMod();
		}
		if (ourModal === "stationThree") {
		closeModal(ourModal);
		}
		*/

		switch (ourModal){
			case "stationOne":
				stationModalMod(ourModal);
			break;
			case "stationTwo":
				stationModalMod(ourModal);
			break;
			case "stationThree":
				closeModal(ourModal);
			break;
			default:
		}
	}
}

function stationModalMod(modalName){
	/*
	console.log(modalName);
	*/
	let modal = document.getElementById(modalName);
	let buttons = modal.getElementsByTagName('button');
	let text = modal.getElementsByTagName('p');
	let buttonOne = buttons[0];
	let buttonTwo = buttons[1];
	let modalWidth = modal.clientWidth;
	let modalHeight = modal.clientHeight;
	let textHeight = text[0].clientHeight;
	let textToPrint = "";
	if (modalName === "stationOne") {
		let printingtext = data.secondpage.steponetwotext;
		textToPrint = printingtext;
	}
	if (modalName === "stationTwo") {
		let printingtext = data.secondpage.steptwotwotext;
		textToPrint = printingtext;
	}
	modal.style.width = modalWidth + "px";
	modal.style.height = modalHeight + "px";
	text[0].style.minHeight = textHeight + "px";
	text[0].innerHTML = "";
	buttonOne.classList.add('hidden');
	setTimeout(function(){buttonOne.style.display = "none"},800)
	/*
	text[0].innerHTML = data.secondpage.steponetwotext;
	*/

	var typedFirstModal = new Typed(text[0], {
			    strings: [textToPrint],
			    typeSpeed: 2,
			    showCursor: false,
			    onComplete: function() { 
					buttonTwo.classList.remove('hidden');
			    }
			  });

}

const modalEndButton = document.querySelectorAll(".modalend");

for(let i = 0; i<modalEndButton.length; i++) {
	modalEndButton[i].onclick = function(){
		let ourModal = this.getAttribute('data-child');
		if ( ourModal === "stationOne" ) { 
			clearInterval(blinkStationTimer);
			ourStation.style.opacity = 1;
		}
		closeModal(ourModal);
	}
}

function firstPinTrigger (e){
	let pins = document.querySelectorAll(".firstpins");
	let clikedPinName = e;
	if ( e === 'cosmoOne' || e === 'cosmoTwo'){
		clearFirstPins(e);
	}
	for(let i = 0; i<pins.length; i++){
		let curPin = pins[i].getAttribute('data-target');
		if ( clikedPinName === curPin ) {
			pins[i].classList.add("active");
		} else{
			pins[i].classList.remove("active");
		}
	}
}

/* modal-window-close */

var closeModalButton = document.querySelectorAll(".closebutton");

for(let i = 0; i<closeModalButton.length; i++) {
    closeModalButton[i].onclick = function(){
	let modal = this.parentElement.getAttribute('data-name');
	closeModal(modal);
	}
}

function closeModal (e) {
	let modals = document.querySelectorAll(".modal");
	for(let i = 0; i<modals.length; i++) {	    
		let modalAttr = modals[i].getAttribute('data-name');
		let modal = modals[i];
	    /* clear first pins */
		if ( e === 'cosmoOne' || e === 'cosmoTwo'){
			clearFirstPins(e);    	
		}
	    /* pause youtube on close */
		if ( modalAttr === 'youtube'){
			let iframe = document.getElementsByTagName("iframe")[0].contentWindow;
			iframe.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
		}
		/* automatic sous after video */
		if ( modalAttr === 'youtubemanual' &&  modalAttr === e ){
			let iframe = document.getElementById("automove").contentWindow;
			iframe.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
			autoDocking();
		}
		if ( modalAttr === e ){
			modal.classList.add("hidden");
		}
		if ( e === "stationOne" ) { 
			clearInterval(blinkStationTimer);
			ourStation.style.opacity = 1;
		}
	}
	if( e ===  "stationOne" || e ===  "stationTwo" || e ===  "stationThree"  ) {
		secondPinTrigger(e);
	}

	if( checkOne === true && checkTwo === true && thirdend === false){ thirdStep() }
	if (fourthend === true) {
		happyEnding();
	}
}

function clearFirstPins(pinname) {
	let pins = document.querySelectorAll(".firstpins");
	for(let i = 0; i<pins.length; i++){
		pins[i].classList.remove("active");
		let thispin = pins[i].getAttribute('data-target');
		if (thispin === pinname){
			pins[i].classList.remove("signal");
		}		
	}
	if( pinname === 'cosmoOne'){ checkOne = true }
	if( pinname === 'cosmoTwo'){ checkTwo = true }
}

const manualButton = document.getElementById('manualsous');
const ourStation = document.getElementById('stationimg');

manualButton.addEventListener("click", manualDocking);

var blinkTimer = 3;

var blinkStationTimer = setInterval(function() {
	blinkTimer = Math.floor(Math.random() * 5) + 1;
	blinkStation();
}, blinkTimer  * 1000);


function blinkStation() {
	if (isMobile){ console.log() } else{
	let blinkCount = Math.floor(Math.random() * 3) + 1;
		for (let i = 0; i<blinkCount; i++){
			setTimeout(function(){
				ourStation.style.opacity = 0.7;
				setTimeout(function(){
					ourStation.style.opacity = 1;
				},100);
			}, i*200);
		}
	}
}

/*
setTimeout(function() {
  clearInterval(timerId);
  alert( 'стоп' );
}, 5000);


function checkBlink(){
 if ( stopBlink === false ){
	launchBlinking();
 } else{
	TweenMax.to(ourStation, 1, {opacity: 1});
 }
}
*/

function thirdStep() {
	document.getElementById("first-pins").classList.add('hidepins');
	document.getElementById("second-buttons-block").classList.remove('hidden');
	niceBg.classList.remove('hidden');
	/*
	manualDocking();
	*/
}

function timedThirdStep () {
	setTimeout(function(){		
		document.getElementById("second-buttons-block").classList.remove('hidden');
		niceBg.classList.remove('hidden');
	},3800);
}

function autoDocking(){
	document.getElementById("first-pins").classList.add('hidepins');
	/* check if draggable obj are created and kill it */
	if (Draggable.get(ship)){
		Draggable.get(ship).kill();
		ship.removeAttribute("style");
		handContainer.classList.add("hidden");
	}
	if(isMobile){
	let shipSize = ship.getBoundingClientRect();
	let stationSize = document.getElementById('station').getBoundingClientRect();
	let ofs = shipSize.bottom - stationSize.top;
	TweenMax.to(ship, 5, {
	  delay: 0.9,
	  bottom: ofs-70,
	  ease: Power1.easeOut,
	  onComplete: stepFour
	});
	} else{
	TweenMax.to(ship, 5, {
	  delay: 0.9,
	  left: 0,
	  ease: Power1.easeOut,
	  onComplete: stepFour
	});
	}
}

function stepFour() {
	thirdend = true;
	document.getElementById("second-buttons-block").classList.add('hidden');
	document.getElementById("second-pins").classList.remove('hidepins');
}


function happyEnding() {
	document.getElementById("second-pins").classList.add('hidepins');
	setTimeout(function(){
		document.getElementById("second-pins").style.display = 'none';
	},1200);
	setTimeout(function(){
		document.getElementById("lastpincontainer").style.display = 'block';
	},1300);
	setTimeout(function(){
		document.getElementById("lastpincontainer").classList.remove('hidden');
	},1300);
	
	setTimeout(function(){
		let boomElements = document.querySelectorAll('.bah');
		for (let i in boomElements) {
			boomElements[i].classList.add('explode');
		}

	},2800);
	setTimeout(function(){
		openModal('boom');
		analytics.event('event', 'complete', { eventLabel: 'user reach final - explode modal open' });
		analytics.name('clientTracker').event('event', 'complete', { eventLabel: 'user reach final - explode modal open' });
	},4000);
}
document.getElementById("startmission").addEventListener("click", function(){
		analytics.event('button', 'click', { eventLabel: 'start mission' });
		analytics.name('clientTracker').event('button', 'click', { eventLabel: 'start mission' });
	});
document.getElementById("hb3").addEventListener("click", function(){
		analytics.event('button', 'click', { eventLabel: 'odnoklasniki share' });
		analytics.name('clientTracker').event('button', 'click', { eventLabel: 'odnoklasniki share' });
	});
document.getElementById("hb2").addEventListener("click", function(){
		analytics.event('button', 'click', { eventLabel: 'vkontakte share' });
		analytics.name('clientTracker').event('button', 'click', { eventLabel: 'vkontakte share' });
	});
document.getElementById("hb1").addEventListener("click", function(){
		analytics.event('button', 'click', { eventLabel: 'facebook share' });
		analytics.name('clientTracker').event('button', 'click', { eventLabel: 'facebook share' });
	});
document.getElementById("trailetwatch").addEventListener("click", function(){
		analytics.event('button', 'click', { eventLabel: 'watch trailer' });
		analytics.name('clientTracker').event('button', 'click', { eventLabel: 'watch trailer' });
	});
document.getElementById("buytickets").addEventListener("click", function(){
		analytics.event('button', 'click', { eventLabel: 'buy tickets' });
		analytics.name('clientTracker').event('button', 'click', { eventLabel: 'buy tickets' });
	});

document.getElementById("fpin").addEventListener("click", function(){
		analytics.event('button', 'click', { eventLabel: 'first pin' });
		analytics.name('clientTracker').event('button', 'click', { eventLabel: 'first pin' });
	});

document.getElementById("secpin").addEventListener("click", function(){
		analytics.event('button', 'click', { eventLabel: 'second pin' });
		analytics.name('clientTracker').event('button', 'click', { eventLabel: 'second pin' });
	});

document.getElementById("manualsous").addEventListener("click", function(){
		analytics.event('button', 'click', { eventLabel: 'manual docking' });
		analytics.name('clientTracker').event('button', 'click', { eventLabel: 'manual docking' });
	});

document.getElementById("autodock").addEventListener("click", function(){
		analytics.event('button', 'click', { eventLabel: 'watch autodocking' });
		analytics.name('clientTracker').event('button', 'click', { eventLabel: 'watch autodocking' });
	});

document.getElementById("spinone").addEventListener("click", function(){
		analytics.event('button', 'click', { eventLabel: 'first red pin' });
		analytics.name('clientTracker').event('button', 'click', { eventLabel: 'first red pin' });
	});

document.getElementById("spintwo").addEventListener("click", function(){
		analytics.event('button', 'click', { eventLabel: 'second red pin' });
		analytics.name('clientTracker').event('button', 'click', { eventLabel: 'second red pin' });
	});
document.getElementById("spinthree").addEventListener("click", function(){
		analytics.event('button', 'click', { eventLabel: 'third red pin' });
		analytics.name('clientTracker').event('button', 'click', { eventLabel: 'third red pin' });
	});
document.getElementById("batteryfirstbutton").addEventListener("click", function(){
		analytics.event('button', 'click', { eventLabel: 'battery modal first button' });
		analytics.name('clientTracker').event('button', 'click', { eventLabel: 'battery modal first button' });
	});
document.getElementById("batterysecondbutton").addEventListener("click", function(){
		analytics.event('button', 'click', { eventLabel: 'battery modal second button' });
		analytics.name('clientTracker').event('button', 'click', { eventLabel: 'battery modal second button' });
	});
document.getElementById("gotosousbutton").addEventListener("click", function(){
		analytics.event('button', 'click', { eventLabel: 'sous modal button' });
		analytics.name('clientTracker').event('button', 'click', { eventLabel: 'sous modal button' });
	});
document.getElementById("gotosousbuttontwo").addEventListener("click", function(){
		analytics.event('button', 'click', { eventLabel: 'sous second modal button' });
		analytics.name('clientTracker').event('button', 'click', { eventLabel: 'sous second modal button' });
	});
document.getElementById("getwater").addEventListener("click", function(){
		analytics.event('button', 'click', { eventLabel: 'get water modal button' });
		analytics.name('clientTracker').event('button', 'click', { eventLabel: 'get water modal button' });
	});
document.getElementById("wtlast").addEventListener("click", function(){
		analytics.event('button', 'click', { eventLabel: 'watch trailer last modal' });
		analytics.name('clientTracker').event('button', 'click', { eventLabel: 'watch trailer last modal' });
	});
document.getElementById("btlast").addEventListener("click", function(){
		analytics.event('button', 'click', { eventLabel: 'buy tickets last modal' });
		analytics.name('clientTracker').event('button', 'click', { eventLabel: 'buy tickets last modal' });
	});
document.getElementById("menutoggle").addEventListener("click", function(){
		analytics.event('button', 'click', { eventLabel: 'mobile menu toggle' });
		analytics.name('clientTracker').event('button', 'click', { eventLabel: 'mobile menu toggle' });
	});
document.getElementById("fcclose").addEventListener("click", function(){
		analytics.event('button', 'click', { eventLabel: 'first spaceman modal close' });
		analytics.name('clientTracker').event('button', 'click', { eventLabel: 'first spaceman modal close' });
	});
document.getElementById("scclose").addEventListener("click", function(){
		analytics.event('button', 'click', { eventLabel: 'second spaceman modal close' });
		analytics.name('clientTracker').event('button', 'click', { eventLabel: 'second spaceman modal close' });
	});
document.getElementById("probone").addEventListener("click", function(){
		analytics.event('button', 'click', { eventLabel: 'first problem modal close' });
		analytics.name('clientTracker').event('button', 'click', { eventLabel: 'first problem modal close' });
	});
document.getElementById("probtwo").addEventListener("click", function(){
		analytics.event('button', 'click', { eventLabel: 'second problem modal close' });
		analytics.name('clientTracker').event('button', 'click', { eventLabel: 'second problem modal close' });
	});
document.getElementById("probthree").addEventListener("click", function(){
		analytics.event('button', 'click', { eventLabel: 'third problem modal close' });
		analytics.name('clientTracker').event('button', 'click', { eventLabel: 'third problem modal close' });
	});
document.getElementById("afishalink").addEventListener("click", function(){
		analytics.event('button', 'click', { eventLabel: 'afisha link click' });
		analytics.name('clientTracker').event('button', 'click', { eventLabel: 'afisha link click' });
	});
document.getElementById("btmob").addEventListener("click", function(){
		analytics.event('button', 'click', { eventLabel: 'buy tickets mobile menu' });
		analytics.name('clientTracker').event('button', 'click', { eventLabel: 'buy tickets mobile menu' });
	});
/* eslint-disable no-inner-declarations */

/*
var c,
	ctx,
	w,
	h,
	cx,
	cy,
	branches,
	startHue,
	tick;

function rand( min, max ) {
	return Math.random() * ( max - min ) + min;
}

function randInt( min, max ) {
	return Math.floor( min + Math.random() * ( max - min + 1 ) );
}

function Branch( hue, x, y, angle, vel ) {
	var move = 15;
	this.x = x + rand( -move, move );
	this.y = y + rand( -move, move );
	this.points = [];
	this.angle = angle !== undefined ? angle : rand( 0, Math.PI * 1 );
	this.vel = vel !== undefined ? vel : rand( -4, 4 );
	this.spread = 0;
	this.tick = 0;
	this.hue = hue !== undefined ? hue : 340;
	this.life = 1;
	this.decay = 0.0015;
	this.dead = false;
	
	this.points.push({
		x: this.x,
		y: this.y
	});
}

Branch.prototype.step = function( i ) {
	this.life -= this.decay;
	if( this.life <= 0 ) {
		this.dead = true;	
	}
	
	if( !this.dead ) {
		var lastPoint = this.points[ this.points.length - 1 ];
		this.points.push({
			x: lastPoint.x + Math.cos( this.angle ) * this.vel,
			y: lastPoint.y + Math.sin( this.angle ) * this.vel
		});
		this.angle += rand( -this.spread, this.spread );
		this.vel *= 0.99;
		this.spread = this.vel * 0.04;
		this.tick++;
		this.hue += 0.3;
	} else {
		branches.splice( i, 1 );
	}
};

Branch.prototype.draw = function() {
	if( !this.points.length || this.dead ) {
		return false;
	}
	
	var length = this.points.length,
		i = length - 1,
		point = this.points[ i ],
		lastPoint = this.points[ i - randInt( 5, 100 ) ];
		//jitter = 8;
	if( lastPoint ) {
		var jitter = 2 + this.life * 6;
		ctx.beginPath();
		ctx.moveTo( lastPoint.x, lastPoint.y );
		ctx.lineTo( point.x + rand( -jitter, jitter ), point.y + rand( -jitter, jitter ) );
		ctx.lineWidth = 1;
		var alpha = this.life * 0.075;
		ctx.strokeStyle = 'hsla(' + ( this.hue ) + ', 70%, 40%, ' + alpha + ')';
		ctx.stroke();
	}
}

function init() {
	c = document.getElementById( 'explosion' );
	ctx = c.getContext( '2d' );
	startHue = 350;
	branches = [];
	reset();
	loop();
}

function reset() {
	w = window.innerWidth;
	h = window.innerHeight;
	cx = w / 2;
	cy = h / 2;
	branches.length = 0;
	c.width = w;
	c.height = h;
	tick = 0;
	
	
	for( var i = 0; i < 500; i++ ) {		
		branches.push( new Branch( startHue, cx, cy) );
	}
}

function step() {
	var i = branches.length;
	while( i-- ) { branches[ i ].step( i ) }
	tick++;
}

function draw() {
	var i = branches.length;
	if( tick < 450 ) {
		ctx.save();
		ctx.globalCompositeOperation = 'lighter';
		ctx.globalAlpha = 0.002;
		ctx.translate( cx, cy );
		var scale = 1 + tick * 0.00025 ;
		ctx.scale( scale, scale );
		ctx.translate( -cx, -cy );
		ctx.drawImage( c, rand( -150, 150 ), rand( -150, 150 ) );
		ctx.restore();
	}
	
	ctx.globalCompositeOperation = 'lighter';
		while( i-- ) { branches[ i ].draw() }
}

function loop() {
	requestAnimationFrame( loop );
	step();
	draw();
	step();
	draw();
}
*/
/*
window.addEventListener( 'resize', reset );
window.addEventListener( 'click', function() {
	startHue = 340;
	reset();
});
init();
*/


/* eslint-enable no-inner-declarations */

/* eslint-enable no-console */
/* eslint-enable no-unused-vars */




// WEBPACK FOOTER //
// ./app.js